import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FaFacebookF, FaTwitter, FaInstagram, FaPhoneAlt, FaEnvelope, FaBars, FaTimes } from 'react-icons/fa';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="w-full fixed top-0 z-50">
      {/* Topbar - Visible seulement sur md et plus grands */}
      <div className="hidden md:block bg-blue-900 text-white text-sm py-2 px-4 lg:px-8">
        <div className="container mx-auto flex justify-between items-center">
          <div className="flex items-center gap-4">
            <div className="flex items-center gap-2">
              <FaPhoneAlt className="text-blue-300" />
              <span>+242 06 172 81 62</span>
              <span>+33 7 58 72 82 89</span>
            </div>
            <div className="w-px h-4 bg-blue-700"></div>
            <div className="flex items-center gap-2">
              <FaEnvelope className="text-blue-300" />
              <span>contact@franceetudes.com</span>
            </div>
          </div>
          
          <div className="flex items-center gap-4">
            <span className="text-blue-300">Suivez-nous :</span>
            <div className="flex gap-3">
              <a href="https://www.facebook.com/share/1GTTGgXk35/?mibextid=wwXIfr" target="_blank" rel="noopener noreferrer" className="text-white hover:text-blue-300 transition-colors" aria-label="Facebook">
                <FaFacebookF />
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="text-white hover:text-blue-300 transition-colors" aria-label="Twitter">
                <FaTwitter />
              </a>
              <a href="https://www.instagram.com/lmk_travel_cg/profilecard/?igsh=bGk4NW5vNmdqOGt6" target="_blank" rel="noopener noreferrer" className="text-white hover:text-blue-300 transition-colors" aria-label="Instagram">
                <FaInstagram />
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Navigation principale */}
      <nav className="bg-white shadow-md">
        <div className="container mx-auto px-4 lg:px-8">
          {/* Barre de navigation principale */}
          <div className="flex justify-between items-center py-3">
            {/* Logo */}
            <Link to="/" className="flex items-center gap-2">
              <img
                src={require('../asset/LOGO.JPG')}
                alt="Logo France Etudes"
                className="h-10 w-auto object-contain"
              />
              <span className="sr-only">FRANCE ETUDES</span>
            </Link>

            {/* Menu desktop - visible à partir de md */}
            <div className="hidden md:flex items-center gap-6 lg:gap-8">
              <ul className="flex gap-4 lg:gap-6">
                <li>
                  <Link 
                    to="/" 
                    className="text-gray-700 hover:text-blue-600 font-medium transition-colors relative
                               after:content-[''] after:absolute after:bottom-0 after:left-0 after:w-0 after:h-0.5 
                               after:bg-blue-600 after:transition-all after:duration-300 hover:after:w-full"
                  >
                    Accueil
                  </Link>
                </li>
                <li>
                  <Link 
                    to="/services" 
                    className="text-gray-700 hover:text-blue-600 font-medium transition-colors relative
                               after:content-[''] after:absolute after:bottom-0 after:left-0 after:w-0 after:h-0.5 
                               after:bg-blue-600 after:transition-all after:duration-300 hover:after:w-full"
                  >
                    Services
                  </Link>
                </li>
                <li>
                  <Link 
                    to="/tarifs" 
                    className="text-gray-700 hover:text-blue-600 font-medium transition-colors relative
                               after:content-[''] after:absolute after:bottom-0 after:left-0 after:w-0 after:h-0.5 
                               after:bg-blue-600 after:transition-all after:duration-300 hover:after:w-full"
                  >
                    Tarifications
                  </Link>
                </li>
                <li>
                  <Link 
                    to="/formations" 
                    className="text-gray-700 hover:text-blue-600 font-medium transition-colors relative
                               after:content-[''] after:absolute after:bottom-0 after:left-0 after:w-0 after:h-0.5 
                               after:bg-blue-600 after:transition-all after:duration-300 hover:after:w-full"
                  >
                    Formations
                  </Link>
                </li>
                <li>
                  <Link 
                    to="/blog" 
                    className="text-gray-700 hover:text-blue-600 font-medium transition-colors relative
                               after:content-[''] after:absolute after:bottom-0 after:left-0 after:w-0 after:h-0.5 
                               after:bg-blue-600 after:transition-all after:duration-300 hover:after:w-full"
                  >
                    Blog
                  </Link>
                </li>
              </ul>
              
              <Link
                to="/contact"
                className="bg-blue-800 hover:bg-blue-700 text-white px-4 py-2 rounded-md 
                          font-medium transition-colors shadow-sm hover:shadow-md transform hover:-translate-y-0.5
                          focus:outline-none focus:ring-2 focus:ring-blue-600 focus:ring-opacity-50"
              >
                Contact
              </Link>
            </div>

            {/* Bouton menu burger - visible seulement sur mobile */}
            <button 
              className="md:hidden text-gray-700 focus:outline-none"
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              aria-label="Menu"
            >
              {isMenuOpen ? <FaTimes size={24} /> : <FaBars size={24} />}
            </button>
          </div>

          {/* Menu mobile - visible seulement quand ouvert */}
          {isMenuOpen && (
            <div className="md:hidden bg-white pb-4">
              <ul className="flex flex-col gap-3 border-t border-gray-200 pt-4">
                <li>
                  <Link 
                    to="/" 
                    className="block py-2 px-4 text-gray-700 hover:bg-blue-50 rounded transition-colors"
                    onClick={() => setIsMenuOpen(false)}
                  >
                    Accueil
                  </Link>
                </li>
                <li>
                  <Link 
                    to="/services" 
                    className="block py-2 px-4 text-gray-700 hover:bg-blue-50 rounded transition-colors"
                    onClick={() => setIsMenuOpen(false)}
                  >
                    Services
                  </Link>
                </li>
                <li>
                  <Link 
                    to="/tarifs" 
                    className="block py-2 px-4 text-gray-700 hover:bg-blue-50 rounded transition-colors"
                    onClick={() => setIsMenuOpen(false)}
                  >
                    Tarifications
                  </Link>
                </li>
                <li>
                  <Link 
                    to="/formations" 
                    className="block py-2 px-4 text-gray-700 hover:bg-blue-50 rounded transition-colors"
                    onClick={() => setIsMenuOpen(false)}
                  >
                    Formations
                  </Link>
                </li>
                <li>
                  <Link 
                    to="/blog" 
                    className="block py-2 px-4 text-gray-700 hover:bg-blue-50 rounded transition-colors"
                    onClick={() => setIsMenuOpen(false)}
                  >
                    Blog
                  </Link>
                </li>
                <li>
                  <Link
                    to="/contact"
                    className="block mt-2 bg-blue-800 text-white text-center py-2 px-4 rounded-md 
                              font-medium transition-colors"
                    onClick={() => setIsMenuOpen(false)}
                  >
                    Contactez-nous
                  </Link>
                </li>
              </ul>
            </div>
          )}
        </div>
      </nav>
    </header>
  );
};

export default Navbar;